import React from 'react';
import { createPortal } from 'react-dom';

const Portal = ({ children }: { children?: React.ReactNode }) => {
    if (typeof document === 'undefined') return null;
    return createPortal(children, document.body);
};

export default Portal;
